import { render, staticRenderFns } from "./cardTeam.vue?vue&type=template&id=5d547174&scoped=true"
import script from "./cardTeam.vue?vue&type=script&lang=js"
export * from "./cardTeam.vue?vue&type=script&lang=js"
import style0 from "./cardTeam.vue?vue&type=style&index=0&id=5d547174&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d547174",
  null
  
)

export default component.exports